import axios from "axios";
import jwt from "jsonwebtoken";
import { AuthResponse, ResetDTO } from "./model";

export type AuthMe = {
  roles: string[];
  username?: string;
  name?: string;
  email?: string;
};
const baseUrl = process.env.REACT_APP_BASEURL.concat(
  "/auth/realms/master/protocol/openid-connect/token"
);

const accountBaseUrl = process.env.REACT_APP_BASEURL.concat(
  "/gateway/account-service/api/v1"
);

const publicAxios = axios.create({ baseURL: baseUrl });
export class AuthService {
  static login(formData: FormData) {
    formData.append("client_id", process.env.REACT_APP_CLIENT_ID);
    formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);
    formData.append("grant_type", process.env.REACT_APP_GRANT_TYPE);
    const data = [...formData];
    const asString = data
      .map(
        (x) =>
          `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1].toString())}`
      )
      .join("&");
    return publicAxios.post<AuthResponse>(baseUrl, asString, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  }

  static refreshToken(refreshToken: string, username: string) {
    const formData = new FormData();
    formData.append("client_id", process.env.REACT_APP_CLIENT_ID);
    formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);
    formData.append("grant_type", "refresh_token");
    formData.append("username", username);
    formData.append("refresh_token", refreshToken);
    const data = [...formData];
    const asString = data
      .map(
        (x) =>
          `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1].toString())}`
      )
      .join("&");
    return publicAxios.post<AuthResponse>(baseUrl, asString, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  }

  static resetPassword(data: ResetDTO) {
    return axios
      .create({ baseURL: accountBaseUrl })
      .post<ResetDTO>("/reset", data);
  }

  static me(): Promise<{ data: AuthMe }> {
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    const username = localStorage.getItem("username");
    if (!accessToken || !refreshToken || !username) {
      return Promise.reject(new Error("no session"));
    }
    const decoded = jwt.decode(accessToken) as {
      realm_access?: { roles?: string[] };
      preferred_username?: string;
      name?: string;
      email?: string;
    } | null;
    if (!decoded) {
      return Promise.reject(new Error("invalid token"));
    }
    return Promise.resolve({
      data: {
        roles: decoded.realm_access?.roles ?? [],
        username: decoded.preferred_username ?? username,
        name: decoded.name,
        email: decoded.email,
      },
    });
  }
}
